import ArrayUtil from '@leverege/array-util'

import Constants from '~/actions/Constants'

function receive( state, action, resetKey, copyKeys ) {

  const nState = {
    total : action.total,
    perPage : action.perPage,
    status : Constants.STATUS_DONE,
    statusMessage : null,
    search : action.search
  }
  if ( copyKeys ) {
    copyKeys.forEach( ( k ) => {
      nState[k] = action[k]
    } )
  }

  const reset = ( resetKey != null && action[resetKey] != state[resetKey] )
  if ( reset || action.search != state.search ) {
    nState.items = new Array( action.total )
  } else {
    nState.items = [].concat( state.items )
  }

  if ( reset ) {
    nState.lookup = {}
  } else {
    nState.lookup = { ...state.lookup }
  }

  // copy new items into the array
  for ( let n = 0, tn = action.startIndex; n < action.items.length; n++, tn++ ) {
    nState.items[tn] = action.items[n]
    nState.lookup[action.items[n].id] = action.items[n]
  }
  return nState
}

function update( state, action ) {
  const nState = { ...state }
  nState.items = [].concat( state.items || [] )
  nState.lookup = { ...state.lookup }

  if ( action.item != null ) {
    ArrayUtil.replace( nState.items, 'id', action.item.id, action.item )
    nState.lookup[action.item.id] = action.item
  }
  return nState;  
}

function add( state, action ) {
  const nState = { ...state }
  nState.lookup = { ...state.lookup }
  nState.items = [].concat( state.items || [] )
  nState.items.push( action.item )
  nState.lookup[action.item.id] = action.item
  return nState;
}

function remove( state, action ) {
  const nState = { ...state }
  nState.lookup = { ...state.lookup }
  nState.items = [].concat( state.items || [] )
  ArrayUtil.remove( nState.items, 'id', action.itemId || action.item.id )
  delete nState.lookup[action.itemId || action.item.id]
  return nState;
}

function reducer( initialState, actionTypeBase, resetKey, copyKeys ) {
  const dis = { error : false, search : null, perPage : 100, total : 0, items : [], lookup : {} }
  if ( resetKey ) {
    dis[resetKey] = null
  }

  initialState = initialState ? { ...dis, ...initialState } : dis

  const STATUS = Constants[`GET_${actionTypeBase}S_STATUS`]
  const GET = Constants[`GET_${actionTypeBase}S`]
  const GET_ONE = Constants[`GET_${actionTypeBase}`]
  const ADD = Constants[`ADD_${actionTypeBase}`]
  const REMOVE = Constants[`REMOVE_${actionTypeBase}`]
  const UPDATE = Constants[`UPDATE_${actionTypeBase}`]

  return function switchCase( state = initialState, action ) {
    switch ( action.type ) {

      case STATUS: {
        const nState = { ...state }
        nState.status = action.status
        return nState
      }
      case GET: return receive( state, action, resetKey, copyKeys )
      case GET_ONE: 
      case UPDATE: return update( state, action )
      case ADD: return add( state, action )
      case REMOVE: return remove( state, action )
      default: return state
    }
  }
}

module.exports = {
  receive,
  add,
  remove,
  update,

  reducer
}
